/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { ApolloClient, InMemoryCache } from '@apollo/client'
import { getGraphqlSchemaURI } from './getGraphqlSchemaURI'
import { isWoman } from './globals'

const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        collection: {
          keyArgs: ['handle', 'id'], // https://www.apollographql.com/docs/react/pagination/key-args/#setting-keyargs
          /**
           * This merge function is used to merge collection products.
           */
          merge(existing, incoming, { args, cache: currentCache }) {
            if (!existing) {
              return incoming
            }

            // If you take a look at Apollo Cache (using console.log) you'll see that products key looks like this:
            // products({first: 100}) so I need to find it.
            const key = Object.keys(incoming).find((k) =>
              k.startsWith('products'),
            )

            if (!key) {
              return incoming
            }

            // Existing results are cached and you only get an object that contains a __ref key.
            // We use the identify function to
            const id = currentCache.identify(existing)

            if (!id) {
              return incoming
            }

            // I'll modify the current cache value for this query as the id has not changed, but the products inside have
            currentCache.modify({
              id,
              fields: {
                /**
                 * Products is the key we want, same as the query.
                 */
                products(existingProductRefs) {
                  // We are merging edges because of Shopify query structure of edges and nodes
                  return {
                    ...incoming[key],
                    edges: [
                      ...existingProductRefs.edges,
                      ...incoming[key].edges,
                    ],
                  }
                },
              },
            })

            return incoming
          },
        },
      },
    },
    ProductConnection: {
      fields: {
        edges: {
          keyArgs: false,
          merge(existing, incoming, { args }) {
            return incoming
          },
        },
      },
    },
  },
})

export const apolloClient = new ApolloClient({
  cache,
  headers: {
    'Content-Type': 'application/json',
    'X-Shopify-Storefront-Access-Token':
      window.$storefront_token ||
      (isWoman ? '46b732a3e33bde2acdb8f9a221780b08' : ''),
  },
  uri: getGraphqlSchemaURI(window.location.origin, isWoman),
})
